var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.header},[_c('div',{class:_vm.$style.header__actions},[_c('HeadButton',{attrs:{"color":"red"}}),_c('HeadButton',{attrs:{"color":"yellow"}}),_c('HeadButton',{attrs:{"color":"green"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }